import { render } from "./ViewTraineeTable.vue?vue&type=template&id=249b14dd&scoped=true"
import script from "./ViewTraineeTable.vue?vue&type=script&lang=js"
export * from "./ViewTraineeTable.vue?vue&type=script&lang=js"

import "./ViewTraineeTable.vue?vue&type=style&index=0&id=249b14dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-249b14dd"]])

export default __exports__